import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InputSwitch } from 'primereact/inputswitch';
import './FollowersOnlyToggle.less';
import { COMMON_TEXT } from 'helpers/common-text';

class FollowersOnlyToggle extends Component {
  render() {
    const { checked, onChange, disabled, className } = this.props;

    return (
      <div className={`followers-only-toggle-container ${className || ''} ${disabled ? 'disabled' : ''}`}>
        <div className="toggle-label-text">{COMMON_TEXT.FOLLOWERS_ONLY}</div>

        <InputSwitch
          id="followers-only-toggle"
          checked={checked}
          onChange={(e) => onChange(e.value)}
          disabled={disabled}
          className="followers-only-toggle"
        />
      </div>
    );
  }
}

FollowersOnlyToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

FollowersOnlyToggle.defaultProps = {
  disabled: false,
  className: '',
};

export default FollowersOnlyToggle;
